import { Pagination as BasePagination } from '@patrianna/core-components'
import type { PaginationProps } from '@patrianna/core-components'
import cx from 'classnames'

import classes from './styles.module.scss'

export default function Pagination({ className, ...props }: PaginationProps) {
  return <BasePagination className={cx(classes.paginationWrapper, className)} {...props} />
}
